/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './array-node.component.scss.shim.ngstyle';
import * as i1 from '../node.component.scss.shim.ngstyle';
import * as i2 from '@angular/core';
import * as i3 from '../any-type-node.component.ngfactory';
import * as i4 from '../../../../../app/multi-editor/json-tree/any-type-node.component';
import * as i5 from '@angular/common';
import * as i6 from '../../../../../app/multi-editor/json-tree/array-node/array-node.component';
const styles_ArrayNodeComponent:any[] = [i0.styles,i1.styles];
export const RenderType_ArrayNodeComponent:i2.RendererType2 = i2.ɵcrt({encapsulation:0,
    styles:styles_ArrayNodeComponent,data:{}});
function View_ArrayNodeComponent_2(_l:any):i2.ɵViewDefinition {
  return i2.ɵvid(0,[(_l()(),i2.ɵeld(0,0,(null as any),(null as any),0,'div',[['class',
      'array-bar']],[[4,'margin-left','px']],(null as any),(null as any),(null as any),
      (null as any)))],(null as any),(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.levelOffsetInPixels;
    _ck(_v,0,0,currVal_0);
  });
}
function View_ArrayNodeComponent_3(_l:any):i2.ɵViewDefinition {
  return i2.ɵvid(0,[(_l()(),i2.ɵeld(0,0,(null as any),(null as any),4,'div',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i2.ɵted(-1,(null as any),['\n        '])),(_l()(),i2.ɵeld(2,0,(null as any),
      (null as any),1,'re-any-type-node',([] as any[]),(null as any),(null as any),
      (null as any),i3.View_AnyTypeNodeComponent_0,i3.RenderType_AnyTypeNodeComponent)),
      i2.ɵdid(3,114688,(null as any),0,i4.AnyTypeNodeComponent,([] as any[]),{value:[0,
          'value'],diff:[1,'diff'],depth:[2,'depth'],expanded:[3,'expanded']},(null as any)),
      (_l()(),i2.ɵted(-1,(null as any),['\n      ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = (<any>_v.parent).context.$implicit;
    const currVal_1:any = _co.patchesMap.get((<any>_v.parent).context.index);
    const currVal_2:any = (_co.depth + 1);
    const currVal_3:any = true;
    _ck(_v,3,0,currVal_0,currVal_1,currVal_2,currVal_3);
  },(null as any));
}
function View_ArrayNodeComponent_4(_l:any):i2.ɵViewDefinition {
  return i2.ɵvid(0,[(_l()(),i2.ɵeld(0,0,(null as any),(null as any),4,'div',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i2.ɵted(-1,(null as any),['\n          '])),(_l()(),i2.ɵeld(2,0,(null as any),
      (null as any),1,'re-any-type-node',([] as any[]),(null as any),(null as any),
      (null as any),i3.View_AnyTypeNodeComponent_0,i3.RenderType_AnyTypeNodeComponent)),
      i2.ɵdid(3,114688,(null as any),0,i4.AnyTypeNodeComponent,([] as any[]),{value:[0,
          'value'],depth:[1,'depth'],expanded:[2,'expanded']},(null as any)),(_l()(),
          i2.ɵted(-1,(null as any),['\n      ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = (<any>_v.parent).context.$implicit;
    const currVal_1:any = (_co.depth + 1);
    const currVal_2:any = true;
    _ck(_v,3,0,currVal_0,currVal_1,currVal_2);
  },(null as any));
}
function View_ArrayNodeComponent_1(_l:any):i2.ɵViewDefinition {
  return i2.ɵvid(0,[(_l()(),i2.ɵeld(0,0,(null as any),(null as any),13,'div',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i2.ɵted(-1,(null as any),['\n    '])),(_l()(),i2.ɵeld(2,0,(null as any),(null as any),
      10,'span',([] as any[]),[[4,'margin-left','px']],(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i2.ɵted(-1,(null as any),['\n      '])),
      (_l()(),i2.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ArrayNodeComponent_2)),
      i2.ɵdid(5,16384,(null as any),0,i5.NgIf,[i2.ViewContainerRef,i2.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i2.ɵted(-1,(null as any),['\n      '])),
      (_l()(),i2.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ArrayNodeComponent_3)),
      i2.ɵdid(8,16384,(null as any),0,i5.NgIf,[i2.ViewContainerRef,i2.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i2.ɵted(-1,(null as any),['\n      '])),
      (_l()(),i2.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ArrayNodeComponent_4)),
      i2.ɵdid(11,16384,(null as any),0,i5.NgIf,[i2.ViewContainerRef,i2.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i2.ɵted(-1,(null as any),['\n    '])),
      (_l()(),i2.ɵted(-1,(null as any),['\n  ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_1:any = (_v.context.index > 0);
    _ck(_v,5,0,currVal_1);
    const currVal_2:any = ((_co.diff && _co.diffKeys.has(_v.context.index)) || _co.shouldExpandKeys);
    _ck(_v,8,0,currVal_2);
    const currVal_3:boolean = ((!_co.diff || !_co.diffKeys.has(_v.context.index)) && !_co.shouldExpandKeys);
    _ck(_v,11,0,currVal_3);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = (_co.depth * _co.levelOffsetInPixels);
    _ck(_v,2,0,currVal_0);
  });
}
export function View_ArrayNodeComponent_0(_l:any):i2.ɵViewDefinition {
  return i2.ɵvid(0,[(_l()(),i2.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_ArrayNodeComponent_1)),i2.ɵdid(1,802816,(null as any),0,i5.NgForOf,[i2.ViewContainerRef,
      i2.TemplateRef,i2.IterableDiffers],{ngForOf:[0,'ngForOf'],ngForTrackBy:[1,'ngForTrackBy']},
      (null as any))],(_ck,_v) => {
    var _co:i6.ArrayNodeComponent = _v.component;
    const currVal_0:any = _co.value;
    const currVal_1:any = _co.trackByIndex;
    _ck(_v,1,0,currVal_0,currVal_1);
  },(null as any));
}
export function View_ArrayNodeComponent_Host_0(_l:any):i2.ɵViewDefinition {
  return i2.ɵvid(0,[(_l()(),i2.ɵeld(0,0,(null as any),(null as any),1,'re-array-node',
      ([] as any[]),(null as any),(null as any),(null as any),View_ArrayNodeComponent_0,
      RenderType_ArrayNodeComponent)),i2.ɵdid(1,114688,(null as any),0,i6.ArrayNodeComponent,
      ([] as any[]),(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const ArrayNodeComponentNgFactory:i2.ComponentFactory<i6.ArrayNodeComponent> = i2.ɵccf('re-array-node',
    i6.ArrayNodeComponent,View_ArrayNodeComponent_Host_0,{value:'value',diff:'diff',
        depth:'depth',expanded:'expanded'},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// /home/travis/build/inspirehep/record-editor/src/$$_gendir/app/multi-editor/json-tree/array-node/array-node.component.ngfactory.ts